/** Bridge between the HTTP layer and whichever auth adapter (Cognito or dev) is active. */
type TokenProvider = () => Promise<string | null>;

let provider: TokenProvider = async () => null;
let unauthorizedHandler: (() => void) | null = null;

export function setTokenProvider(fn: TokenProvider): void {
  provider = fn;
}

export function getAuthToken(): Promise<string | null> {
  return provider().catch(() => null);
}

export function setUnauthorizedHandler(fn: (() => void) | null): void {
  unauthorizedHandler = fn;
}

export function notifyUnauthorized(): void {
  unauthorizedHandler?.();
}
